document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-group-type="accordion-group"]').forEach((group) => {
    group.addEventListener(
      'toggle',
      (e) => {
        if (e.target.matches('details[is="accordion-disclosure"]') && e.target.open) {
          group.querySelectorAll('details[is="accordion-disclosure"]').forEach((acc) => {
            if (acc !== e.target && acc.open) acc.open = false;
          });
        }
      },
      true
    );
  });
});
